const steps = [
  {
    step: 'Adım 1',
    title: 'Reklamdan Başvuru Gelir',
    description:
      'Kişi Instagram, Facebook, WhatsApp veya özel landing page üzerinden sizinle iletişime geçer.',
    icon: 'ri-advertisement-line',
  },
  {
    step: 'Adım 2',
    title: 'Özel Karşılama Akışı Başlar',
    description:
      'Kişiye işinizi tanıtan, sizi rakiplerinizden ayıran, hizmetinizi açıklayan özel mesajlar, görseller, videolar veya sesli içerikler gösterilir.',
    icon: 'ri-chat-smile-2-line',
  },
  {
    step: 'Adım 3',
    title: 'Kişinin Davranışı Analiz Edilir',
    description:
      'Kişi hangi mesaja cevap verdi, hangi aşamada ilgisi arttı, nerede koptu, sadece fiyat mı sordu, gerçekten hizmeti mi değerlendirdi gibi veriler takip edilir.',
    icon: 'ri-bar-chart-grouped-line',
  },
  {
    step: 'Adım 4',
    title: 'Başvurular Kalitesine Göre Ayrılır',
    description:
      'Her başvuru aynı değerde görülmez. Olumlu, olumsuz, satışa yakın, randevu isteyen, tekrar aranacak veya gereksiz başvurular ayrıştırılır.',
    icon: 'ri-filter-3-line',
  },
  {
    step: 'Adım 5',
    title: 'Firma Panelden Süreci Takip Eder',
    description:
      'Firma sahibi panelden gelen kişileri, durumlarını, cevaplarını, randevu veya satış aşamalarını takip eder. Basit işaretlemelerle sistemi besler.',
    icon: 'ri-dashboard-line',
  },
  {
    step: 'Adım 6',
    title: 'Veri Tekrar Reklam Sistemine Geri Döner',
    description:
      'Gerçek müşteri kalitesi reklam tarafına geri bildirilir. Sistem zamanla hangi tip kişilerin daha kaliteli olduğunu öğrenmeye başlar.',
    icon: 'ri-loop-left-line',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50" id="nasil-calisir">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Sistem Adım Adım Nasıl Çalışır?
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 md:-translate-x-px hidden md:block"></div>

          <div className="space-y-8 md:space-y-12">
            {steps.map((item, index) => {
              const isEven = index % 2 === 0;
              return (
                <div
                  key={item.step}
                  className={`flex flex-col md:flex-row items-start gap-4 md:gap-8 ${
                    isEven ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${isEven ? 'md:text-right' : 'md:text-left'}`}>
                    <div className={`flex items-center gap-3 ${isEven ? 'md:justify-end' : 'md:justify-start'} mb-2`}>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
                        {item.step}
                      </span>
                    </div>
                    <h3 className="font-heading font-bold text-foreground-900 text-lg mb-2">
                      {item.title}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  <div className="relative z-10 flex-shrink-0">
                    <div className="w-10 h-10 rounded-full bg-primary-500 border-4 border-background-50 flex items-center justify-center">
                      <i className={`${item.icon} text-background-50 text-sm`}></i>
                    </div>
                  </div>

                  <div className="flex-1 hidden md:block"></div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-foreground-500 text-sm max-w-2xl mx-auto">
            Amaç daha fazla gereksiz mesaj almak değil,{' '}
            <strong className="text-foreground-800">daha doğru kişilere ulaşmayı sağlamaktır.</strong>
          </p>
        </div>
      </div>
    </section>
  );
}